/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_COUNTRY, ENV_FUNCTION_PANEL_TRACKING } from '../../hooks/enviroment'

export async function serviceApproveByQf(item) {
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_PANEL_TRACKING}/approve-register/judgment/${ENV_COUNTRY}`,
		data: {
			page: 1,
			limit: 10,
			rut: item.rut,
			code_internal: item.code_internal,
			pharmacy: item.pharmacy,
		},
	})
		.then(async (response) => {
			if (response.data.statusCode === 200) {
				return response.data.data
			} else {
				notification.error({
					message: response.error,
					description: response.message,
				})
				return { data: response.data }
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_PANEL_TRACKING}/approve-register/judgment/${ENV_COUNTRY}`,
			})
		})
}
